import { render } from "./MMSelfAssessment.vue?vue&type=template&id=895bf3fe&scoped=true"
import script from "./MMSelfAssessment.vue?vue&type=script&lang=js"
export * from "./MMSelfAssessment.vue?vue&type=script&lang=js"

import "./MMSelfAssessment.vue?vue&type=style&index=0&id=895bf3fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895bf3fe"]])

export default __exports__